import React from "react";
export default function HowItWorksPage() {
  return (
    <section className="section">
      <div className="container-gb">
        <p className="eyebrow">Hogyan működik?</p>
        <h1 className="h-lg">A folyamat lépésről lépésre.</h1>
        <p className="lead muted" style={{ marginTop: 20 }}>A XVII. kerületben keletkező megfelelő növényi alapanyagtól a kész GrowBagig — minden helyben történik.</p>
        <ol className="flow" style={{ marginTop: 48 }}>
          <li><span className="num">01</span><span className="label">Növényi alapanyag</span><span className="hint">Megfelelő növényi szerves anyag a környékről.</span></li>
          <li><span className="num">02</span><span className="label">Begyűjtés</span><span className="hint">A XVII. kerületben kijelölt pontokon.</span></li>
          <li><span className="num">03</span><span className="label">Komposztálás</span><span className="hint">Kontrollált körülmények között.</span></li>
          <li><span className="num">04</span><span className="label">Érlelés</span><span className="hint">Lassú érlelés, stabil anyag.</span></li>
          <li className="is-product"><span className="num">05</span><span className="label">GrowBag</span><span className="hint">Prémium kiszerelésben, helyi márkanévvel.</span></li>
          <li><span className="num">06</span><span className="label">Helyi kert</span><span className="hint">Vissza a környék kertjeibe.</span></li>
        </ol>
      </div>
    </section>
  );
}
